import React from "react";
import clsx from "clsx";
import Text from "../../../../../shared-components/css-modules/toyota/atoms/Text";
import Button from "../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./ContentSection.module.scss";
import type { GradeFeaturesType } from "../../../../redux/slices/CarConfigGradesSlice";
import { useCarConfigSelector } from "../../../../redux/store";
import { getCarDBAssetSrcSet } from "../../../../../../shared-logic/utils/imageUtils";
import useAphModal from "../../../../hooks/useAphModal";
import { MODAL_HIGHLIGHT_FEATURE } from "../../../../utils/modalConstants";
import { CarConfigLabel } from "../../../../utils/labelUtils";

export type ContentSectionProps = {
    gradeFeature: GradeFeaturesType;
    contentPosition?: "start" | "end";
};
const ContentSection = (props: ContentSectionProps): JSX.Element => {
    const { contentPosition = "start", gradeFeature } = props;
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);

    const { showModalHelper } = useAphModal();

    return (
        <article
            className={clsx(styles.wrapper, contentPosition && styles[contentPosition])}
            data-images={gradeFeature.assets.length}
        >
            <div className={styles.images}>
                {gradeFeature.assets.map((asset) => (
                    <figure key={`${asset.url}-${asset.type}`}>
                        <img
                            {...getCarDBAssetSrcSet(
                                commonSettings,
                                [
                                    { width: 180, height: 180 },
                                    { width: 225, height: 225 },
                                    { width: 336, height: 336 },
                                    { width: 386, height: 386 },
                                    { width: 426, height: 426 },
                                    { width: 772, height: 772 },
                                    { width: 852, height: 852 },
                                ],
                                asset.url,
                            )}
                            width="90"
                            height="90"
                            sizes="(max-width: 767px) 45vw, (max-width: 991px) 40vw, (max-width: 1199px) 45vw, 496px"
                            alt=""
                            role="presentation"
                            loading="lazy"
                        />
                    </figure>
                ))}
            </div>
            <div className={styles.content}>
                <Text variant="apheleia-body" className={styles.subtitle} spacing="spacing-2">
                    {gradeFeature.name}
                </Text>
                <Text tag="h2" variant="apheleia-border-title" className={styles.title}>
                    {gradeFeature.subtitle}
                </Text>
                <Text variant="apheleia-body" spacing="spacing-2" tag="div">
                    <span dangerouslySetInnerHTML={{ __html: gradeFeature.description }} />
                </Text>
                {/*TODO This should be able to link to a certain configure step*/}
                {/*<Button variant="apheleia-text">Configure</Button>*/}
                {/*TODO on the other hand this could be a panel -> this is an example panel */}
                {gradeFeature.learnMore && (
                    <>
                        <Button
                            variant="apheleia-text"
                            onClick={(event) => {
                                event.preventDefault();
                                showModalHelper(MODAL_HIGHLIGHT_FEATURE, { gradeFeature });
                            }}
                        >
                            <CarConfigLabel label="carConfigHighlightsLearnMore" />
                        </Button>
                    </>
                )}
            </div>
        </article>
    );
};

export default ContentSection;
